import { render, staticRenderFns } from "./juegos_asignatura.vue?vue&type=template&id=8236d2fc"
import script from "./juegos_asignatura.vue?vue&type=script&lang=js"
export * from "./juegos_asignatura.vue?vue&type=script&lang=js"
import style0 from "./juegos_asignatura.vue?vue&type=style&index=0&id=8236d2fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports